module.exports = __webpack_public_path__ + "media/assets/svgs/yahooCalendarIcon-1b12802cbfa92a011896e4fde592a2a2.svg";